import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2024 Savory Haven. All rights reserved.</p>
        <p>123 Gourmet Street, Culinary District, NY 10001 | (555) 123-4567</p>
        <p>Follow us on social media for updates and special offers!</p>
      </div>
    </footer>
  );
};

export default Footer;
